import { render } from "./index.vue?vue&type=template&id=46578598&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=46578598&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-46578598"

export default script